import { useState, useCallback } from "react";

export function useCollectionFeatures() {
  // Feature filter state for collection gallery
  const [featureSearchQuery, setFeatureSearchQuery] = useState("");
  const [featureSearchResults, setFeatureSearchResults] = useState([]);
  const [selectedFeatures, setSelectedFeatures] = useState([]); // Array of {type, value}
  const [showFeatureDropdown, setShowFeatureDropdown] = useState(false);

  // Add game dropdown state
  const [showAddGameDropdown, setShowAddGameDropdown] = useState(false);
  const [addGameSearchQuery, setAddGameSearchQuery] = useState("");
  const [addGameResults, setAddGameResults] = useState([]);

  const addFeature = useCallback((type, value) => {
    setSelectedFeatures(prev => {
      // Check if already exists
      if (prev.find(f => f.type === type && f.value === value)) {
        return prev;
      }
      return [...prev, { type, value }];
    });
  }, []);

  const removeFeature = useCallback((type, value) => {
    setSelectedFeatures(prev => prev.filter(f => !(f.type === type && f.value === value)));
  }, []);

  const clearFeatures = useCallback(() => {
    setSelectedFeatures([]);
    setFeatureSearchQuery("");
  }, []);

  const resetFeatureState = useCallback(() => {
    setFeatureSearchQuery("");
    setFeatureSearchResults([]);
    setSelectedFeatures([]);
    setShowFeatureDropdown(false);
    setShowAddGameDropdown(false);
    setAddGameSearchQuery("");
    setAddGameResults([]);
  }, []);

  return {
    // Feature search
    featureSearchQuery,
    setFeatureSearchQuery,
    featureSearchResults,
    setFeatureSearchResults,
    selectedFeatures,
    setSelectedFeatures,
    addFeature,
    removeFeature,
    clearFeatures,
    showFeatureDropdown,
    setShowFeatureDropdown,
    // Add game dropdown
    showAddGameDropdown,
    setShowAddGameDropdown,
    addGameSearchQuery,
    setAddGameSearchQuery,
    addGameResults,
    setAddGameResults,
    resetFeatureState
  };
}
